'use strict';

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopDefault(a) {
  return a && 'object' == typeof a && 'default' in a ? a['default'] : a;
}

var deepmerge = _interopDefault(require('deepmerge')),
    urijs = _interopDefault(require('urijs')),
    qs = _interopDefault(require('qs')),
    isTouchDevice = _interopDefault(require('is-touch-device')),
    uuidv4 = _interopDefault(require('uuid/v4'));

function clamp(a) {
  var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : 0,
      c = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : 1;
  return a < b ? b : a > c ? c : a;
}

function convertHexToRGB() {
  var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : '',
      b = a.substr(1),
      c = new RegExp('.{1,' + b.length / 3 + '}', 'g'),
      d = b.match(c);
  return d && 1 === d[0].length && (d = d.map(function (a) {
    return a + a;
  })), d ? 'rgb(' + d.map(function (a) {
    return parseInt(a, 16);
  }).join(', ') + ')' : '';
}

function decomposeColor() {
  var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : '';
  if ('#' === a.charAt(0)) return decomposeColor(convertHexToRGB(a));
  var b = a.indexOf('('),
      c = a.substring(0, b),
      d = a.substring(b + 1, a.length - 1).split(',');
  if (d = d.map(function (a) {
    return parseFloat(a);
  }), -1 === ['rgb', 'rgba', 'hsl', 'hsla'].indexOf(c)) throw new Error(['@deseretbook/utils: unsupported `' + a + '` color.', 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
  return {
    type: c,
    values: d
  };
}

function recomposeColor() {
  var a = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
      b = a.type,
      c = a.values;
  return -1 !== b.indexOf('rgb') && (c = c.map(function (a, b) {
    return 3 > b ? parseInt(a, 10) : a;
  })), -1 !== b.indexOf('hsl') && (c[1] += '%', c[2] += '%'), a.type + '(' + c.join(', ') + ')';
}

function getLuminance(a) {
  var b = decomposeColor(a);

  if (-1 !== b.type.indexOf('rgb')) {
    var c = b.values.map(function (a) {
      var b = a / 255;
      return .03928 >= b ? b / 12.92 : Math.pow((b + .055) / 1.055, 2.4);
    });
    return +(.2126 * c[0] + .7152 * c[1] + .0722 * c[2]).toFixed(3);
  }

  return b.values[2] / 100;
}

function getContrastRatio(a, b) {
  var c = getLuminance(a),
      d = getLuminance(b);
  return (Math.max(c, d) + .05) / (Math.min(c, d) + .05);
}

function fade(a, b) {
  if (!a) return a;
  var c = decomposeColor(a),
      d = clamp(b);
  return ('rgb' === c.type || 'hsl' === c.type) && (c.type += 'a'), c.values[3] = d, recomposeColor(c);
}

function darken(a, b) {
  if (!a) return a;
  var c = decomposeColor(a),
      d = clamp(b);
  if (-1 !== c.type.indexOf('hsl')) c.values[2] *= 1 - d;else if (-1 !== c.type.indexOf('rgb')) for (var e = 0; 3 > e; e += 1) {
    c.values[e] *= 1 - d;
  }
  return recomposeColor(c);
}

function lighten(a, b) {
  if (!a) return a;
  var c = decomposeColor(a),
      d = clamp(b);
  if (-1 !== c.type.indexOf('hsl')) c.values[2] += (100 - c.values[2]) * d;else if (-1 !== c.type.indexOf('rgb')) for (var e = 0; 3 > e; e += 1) {
    c.values[e] += (255 - c.values[e]) * d;
  }
  return recomposeColor(c);
}

function emphasize(a) {
  var b = 1 < arguments.length && arguments[1] !== void 0 ? arguments[1] : .15;
  return .5 < getLuminance(a) ? darken(a, clamp(b)) : lighten(a, clamp(b));
}

function normalizeColor(a) {
  return a ? recomposeColor(decomposeColor(a)) : '';
}

var _typeof = 'function' == typeof Symbol && 'symbol' == typeof Symbol.iterator ? function (a) {
  return typeof a;
} : function (a) {
  return a && 'function' == typeof Symbol && a.constructor === Symbol && a !== Symbol.prototype ? 'symbol' : typeof a;
},
    defineProperty = function defineProperty(a, b, c) {
  return b in a ? Object.defineProperty(a, b, {
    value: c,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : a[b] = c, a;
},
    _extends = Object.assign || function (a) {
  for (var b, c = 1; c < arguments.length; c++) {
    for (var d in b = arguments[c], b) {
      Object.prototype.hasOwnProperty.call(b, d) && (a[d] = b[d]);
    }
  }

  return a;
},
    slicedToArray = function () {
  function a(a, b) {
    var c = [],
        d = !0,
        e = !1,
        f = void 0;

    try {
      for (var g, h = a[Symbol.iterator](); !(d = (g = h.next()).done) && (c.push(g.value), !(b && c.length === b)); d = !0) {
        ;
      }
    } catch (a) {
      e = !0, f = a;
    } finally {
      try {
        !d && h['return'] && h['return']();
      } finally {
        if (e) throw f;
      }
    }

    return c;
  }

  return function (b, c) {
    if (Array.isArray(b)) return b;
    if (Symbol.iterator in Object(b)) return a(b, c);
    throw new TypeError('Invalid attempt to destructure non-iterable instance');
  };
}();

function uuid() {
  var a = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : '';
  return [a, uuidv4()].filter(Boolean).join('-');
}

var deepClean = function a() {
  var b = 0 < arguments.length && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.entries(b).reduce(function (b, c) {
    var d = slicedToArray(c, 2),
        e = d[0],
        f = d[1];
    return null === f || void 0 === f || Number.isNaN(f) ? b : _extends({}, b, defineProperty({}, e, 'object' === ('undefined' == typeof f ? 'undefined' : _typeof(f)) ? a(f) : f));
  }, {});
},
    SMALL_WORDS = /\b(?:an?d?|a[st]|because|but|by|en|for|i[fn]|neither|nor|o[fnr]|only|over|per|so|some|tha[tn]|the|to|up|upon|vs?\.?|versus|via|when|with|without|yet)\b/i,
    TOKENS = /[^\s:–—-]+|./g,
    WHITESPACE = /\s/,
    IS_MANUAL_CASE = /.(?=[A-Z]|\..)/,
    ALPHANUMERIC_PATTERN = /[A-Za-z0-9\u00C0-\u00FF]/;

function titleCase(a) {
  for (var b, c = ''; null !== (b = TOKENS.exec(a));) {
    var d = b[0],
        e = b.index;

    if (!IS_MANUAL_CASE.test(d) && (!SMALL_WORDS.test(d) || 0 === e || e + d.length === a.length) && (':' !== a.charAt(e + d.length) || WHITESPACE.test(a.charAt(e + d.length + 1)))) {
      c += d.replace(ALPHANUMERIC_PATTERN, function (a) {
        return a.toUpperCase();
      });
      continue;
    }

    c += d;
  }

  return c;
}

exports.merge = deepmerge, exports.URI = urijs, exports.queryString = qs, exports.isTouchDevice = isTouchDevice, exports.toTitleCase = titleCase, exports.convertHexToRGB = convertHexToRGB, exports.decomposeColor = decomposeColor, exports.recomposeColor = recomposeColor, exports.getLuminance = getLuminance, exports.getContrastRatio = getContrastRatio, exports.fade = fade, exports.darken = darken, exports.lighten = lighten, exports.emphasize = emphasize, exports.normalizeColor = normalizeColor, exports.uuid = uuid, exports.deepClean = deepClean;